import type { PatientListItem, PatientRecord } from './types';
import { PP_DEFAULT_MOCK_PATIENT_ID, PP_MOCK_PATIENT_IDS } from './config';

export function formatPatientMoney(n: number): string {
  return `$${n.toLocaleString()}`;
}

export const ppEyebrowClass =
  'font-[var(--font-mono)] text-[9.5px] font-bold uppercase tracking-[0.12em]';

export function patientsHeaderStats(list: PatientListItem[]) {
  const total = list.length;
  const active = list.filter((p) => p.statusTone === 'success' || p.statusTone === 'ai').length;
  const overdue = list.filter((p) => p.overdue).length;
  return { total, active, overdue };
}

export function patientProfileHeaderStats(patient: PatientRecord) {
  return {
    visits: patient.visits,
    since: patient.since,
    age: patient.age,
  };
}

export function getPatientById(id: string, patients: PatientRecord[]): PatientRecord | undefined {
  return patients.find((p) => p.id === id);
}

/** Maps route id to a canonical mock patient key (directory ids fall back to Amara). */
export function resolvePatientMockBundleKey(patientId: string): string {
  return (PP_MOCK_PATIENT_IDS as readonly string[]).includes(patientId)
    ? patientId
    : PP_DEFAULT_MOCK_PATIENT_ID;
}
